const textRadius = 35;
export default {
    data: () => ({
        showPopup: false,
        choosingHour: true,
        hour: undefined,
        minute: undefined,
        hourHover: undefined,
        minuteHover: undefined,
        time: undefined,
        mobile: false,
        oldValue: undefined,
    }),
    props: ["value", "amColor", "pmColor", "mobileQuery", "isAMorPM", "isAM", "isShow", "emitOnApply"],
    methods: {
        emit() {
            this.$emit("input", this.time);
        },
        removeClock() {
            this.time = this.oldValue;
            this.showPopup = false;
        },
        setTimeFromFields() {
            let minute;
            if (this.minute === undefined) {
                minute = "00";
            }
            else {
                if (this.minute < 10) {
                    minute = "0" + this.minute;
                }
                else {
                    minute = "" + this.minute;
                }
            }
            const hour = this.hour === undefined ? "12" : this.hour;
            if (this.isAMorPM) {
                let period = this.isAM ? "AM" : "PM";
                this.time = hour + ":" + minute + " " + period;
            }
            else {
                let period = "AM";
                if (this.$refs.period && this.$refs.period.checked) {
                    period = "PM";
                }
                this.time = hour + ":" + minute + " " + period;
            }
            if (this.emitOnApply == undefined || !this.emitOnApply) {
                this.emit();
            }
        },
        setFieldsFromValue(value) {
            const time = value.match(/(\d+):(\d+)\s(.+)/);
            if (time && time.length === 4) {
                this.hour = +time[1];
                this.minute = +time[2];
                if (this.isAM) {
                    if (this.$refs.period) {
                        this.$refs.period = "AM";
                    }
                }
                else {
                    if (this.$refs.period) {
                        this.$refs.period.checked = time[3] === "PM";
                    }
                }
                this.time = value;
            }
            else {
                console.error("Invalid time, must be in the format h:mm A");
            }
        },
        chooseHour(i) {
            this.hour = i;
            this.hourHover = undefined;
            if (!this.mobile) {
                this.choosingHour = false;
            }
            this.setTimeFromFields();
        },
        chooseMinute(i) {
            this.minute = i;
            this.minuteHover = undefined;
            this.setTimeFromFields();
        },
        touchHover(ev) {
            if (this.choosingHour) {
                this.hourHover = this.getSelectionFromTouchEvent(ev, Math.PI / 6);
            }
            else {
                this.minuteHover = this.getSelectionFromTouchEvent(ev, Math.PI / 30);
            }
        },
        touchSelect(ev) {
            if (this.choosingHour) {
                this.chooseHour(this.getSelectionFromTouchEvent(ev, Math.PI / 6));
            }
            else {
                this.chooseMinute(this.getSelectionFromTouchEvent(ev, Math.PI / 30));
            }
        },
        getSelectionFromTouchEvent(ev, unit) {
            const touch = ev.changedTouches[0];
            const rect = ev.target.getBoundingClientRect();
            const x = touch.clientX - rect.left - rect.width / 2;
            const y = rect.height / 2 - touch.clientY + rect.top;
            let rad = Math.atan2(x, y);
            if (rad < 0) {
                rad += 2 * Math.PI;
            }
            return Math.round(rad / unit);
        },
        apply() {
            this.showPopup = false;
            this.choosingHour = true;
            this.oldValue = this.time;
            this.emit();
        },
    },
    watch: {
        value(value) {
            if (value) {
                this.setFieldsFromValue(value);
            }
        },
        isShow(newVal) {
            this.showPopup = newVal;
        },
        showPopup(newVal) {
            if (newVal && !this.isShow) {
                this.$emit("update:isShow", false);
            }
        },
    },
    computed: {
        minuteHandDegrees() {
            if (this.minuteHover === undefined) {
                return this.minute === undefined ? undefined : this.minute * 6;
            }
            else {
                return this.minuteHover * 6;
            }
        },
        hourHandDegrees() {
            if (this.hourHover === undefined) {
                if (this.hour === undefined) {
                    return undefined;
                }
                if (this.minuteHandDegrees) {
                    return this.minuteHandDegrees / 12 + this.hour * 30;
                }
                else {
                    return this.hour * 30;
                }
            }
            else {
                if (this.minuteHandDegrees !== undefined) {
                    return this.minuteHandDegrees / 12 + this.hourHover * 30;
                }
                else {
                    return this.hourHover * 30;
                }
            }
        },
        cssVars() {
            let result = "";
            if (this.amColor) {
                result += "--am-color: " + this.amColor + "; ";
            }
            if (this.pmColor) {
                result += "--pm-color: " + this.pmColor + "; ";
            }
            return result;
        },
    },
    mounted() {
        if (this.value) {
            this.setFieldsFromValue(this.value);
        }
        if (this.mobileQuery) {
            this.mobile = window.matchMedia(this.mobileQuery).matches;
        }
        else {
            this.mobile = window.matchMedia("only screen and (max-width : 839px)").matches;
        }
    },
    created() {
        if (this.value != "NOW" && this.value != "now") {
            this.oldValue = this.value;
        }
    },
};
